import { Component, ViewEncapsulation } from '@angular/core';
import { LocaleService } from '../../services/locale.service';
import { Language } from '../../types/language.type';

@Component({
    selector: 'locale-switch',
    templateUrl: './locale.component.html',
    styleUrls: ['./locale.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class LocaleComponent {

    constructor(
        private localeService: LocaleService
    ) { }

    get languages(): Language[] {
        return this.localeService.languages;
    }

    get activeLanguage(): Language {
        return this.localeService.defaultLanguage;
    }

    changeLanguage(language: Language): void {
        this.localeService.changeLanguage(language);
    }
}
